'use client';

import { useDeviceYmm } from '@/hooks/useDeviceYmm';
import styles from './maiacard.module.scss';
import { useYmmDomData } from '@/hooks/useYmmDomData';
import { Grid } from '../../atoms/Layout/Grid/Grid';

export function PlanCardYmmBanner() {
    const { data } = useYmmDomData();
    const { ymm } = useDeviceYmm(data ?? { student: '', tokenType: '' });
    if (!data || !ymm) return <span className={styles.emptyRow} />;

    return (
        <Grid container>
            <Grid col={{ sm: 12 }}>
                <div className={styles.ymmBanner}>
                    <strong>{ymm.last4DigitsOfRadioId ? 'Radio ID: ' : 'Your vehicle: '}</strong>
                    {ymm.last4DigitsOfRadioId
                        ? `****${ymm.last4DigitsOfRadioId}`
                        : [ymm.year, ymm.make, ymm.model].filter(Boolean).join(' ')}
                </div>
            </Grid>
        </Grid>
    );
}
